import { render } from "./SearchHeroes.vue?vue&type=template&id=cdc4f4d0"
import script from "./SearchHeroes.vue?vue&type=script&lang=js"
export * from "./SearchHeroes.vue?vue&type=script&lang=js"

import "./SearchHeroes.vue?vue&type=style&index=0&id=cdc4f4d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__